import { jsx } from '@emotion/react/jsx-runtime';
import { createPolymorphicComponent, useSlot } from '@nettbureau/core';
import { useCss } from '@nettbureau/styling';

/**
 * A spacer component can be used directly inside a flex container to fill the space between two
 * items. Instead of using "space-between" to align items on each side of a container, you can
 * instead use a spacer between them.
 */ const Spacer = createPolymorphicComponent((props, ref)=>{
    const [mergedProps, mergedRef] = useSlot('Spacer', props, ref);
    const { as: Component = 'div', className, css } = mergedProps;
    const spacerCss = useCss({
        flexGrow: 1
    });
    return /*#__PURE__*/ jsx(Component, {
        ref: mergedRef,
        className: className,
        css: [
            spacerCss,
            css
        ]
    });
});

export { Spacer };
//# sourceMappingURL=spacer.js.map
